<template>
  <div class="events-pricing">
    <bp-select
      required
      class="mb-6"
      label="Moeda base"
      v-model="form.currency"
      description="Em caso de venda para outros países, usaremos esta moeda como base para conversão."
      :options="[{ id: 'BRL', name: 'Real Brasileiro' }]"
    />

    <payment-methods v-model="form.payment_methods_ids" isEvent class="mb-6" />

    <template v-if="isParceledBillet">
      <bp-select
        v-model="form.billet_installments"
        class="my-5"
        label="Parcelamento"
        description="Defina o número máximo de parcelas no boleto."
        :options="billetInstallmentOptions"
      />

      <bp-switch
        v-model="form.billet_apply_interest"
        label="Taxa sobre parcelamento de boletos"
      />
      <div class="functional-2 text-neutral-400 mb-6">
        Em uma compra parcelada por boletos, serão aplicados juros sobre as
        parcelas.
      </div>
    </template>

    <template v-else-if="isCardSale">
      <bp-select
        v-model="form.installments"
        class="my-6"
        id="installment"
        label="Parcelamento"
        placeholder="Selecionar..."
        description="Defina o número máximo de parcelas."
        :options="installmentOptions"
      />

      <div class="d-flex align-items-center mt-5">
        <b-form-checkbox
          v-model="form.is_tax_to_producer"
          switch
          class="mr-5 text-switch"
          id="product-status"
        >
          Taxas para o produtor
        </b-form-checkbox>
      </div>
      <span class="small-text text-secondary">
        Em uma compra parcelada, o produtor pagará as taxas do parcelamento
      </span>
    </template>

    <bp-select
      required
      v-model="form.warranty"
      label="Prazo para solicitação de reembolso"
      description="Este é também o prazo que o cliente tem para pedir reembolso do evento. No Brasil, o prazo mínimo é de 7 dias e na União Europeia, de 15 dias. "
      :options="warranties"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import PaymentMethods from "../PaymentMethods.vue";
export default {
  components: { PaymentMethods },
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      cb: []
    };
  },
  computed: {
    ...mapState("product", ["warranties"]),
    isParceledBillet() {
      return !!this.form.payment_methods_ids.find(p => p == "parceled_billet");
    },
    isCardSale() {
      return !!this.form.payment_methods_ids.find(p => [1, 3, 34].includes(p));
    },
    installmentOptions() {
      let options = [];
      for (let i = 1; i <= 12; i++) {
        options.push({ id: i, name: `Em até ${i} x` });
      }
      return options;
    },
    billetInstallmentOptions() {
      return Array(12)
        .fill()
        .map((_, i) => ({
          id: i + 1,
          name: `Até ${i + 1} parcela${i ? "s" : ""}`
        }));
    }
  }
};
</script>
